module.exports = __webpack_public_path__ + "static/media/exhibition-services-img21.61d1b724.jpg";